var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummerLinkedinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.225 3.26087C6.225 5.06217 4.8375 6.52174 3.125 6.52174C1.4125 6.52174 0.025 5.06217 0.025 3.26087C0.025 1.46087 1.4125 0 3.125 0C4.8375 0 6.225 1.46087 6.225 3.26087ZM6.25 9.13043H0V30H6.25V9.13043ZM16.2275 9.13043H10.0175V30H16.2288V19.0448C16.2288 12.9535 23.765 12.4552 23.765 19.0448V30H30V16.7857C30 6.50739 18.8475 6.88174 16.2275 11.9413V9.13043Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummerLinkedinLogo);
export default __webpack_public_path__ + "static/media/summer_linkedin_logo.c85f844c7c6aceb84072be9036f438d4.svg";
export { ForwardRef as ReactComponent };